import type { InternalAxiosRequestConfig } from 'axios';

import { getNewToken } from './domain.new';
import { fetchRefreshToken, getStoredTokens, setStoredTokens } from './repository';
export const uefatvClientEvents = {
  ERROR: 'uefatv.client.error',
} as const;
export const refreshTokens = async () => {
  const { refreshToken: currentRefreshToken, authorisationToken: bearerToken, tokenType } = await getStoredTokens();

  if (!currentRefreshToken) return getNewToken();

  const response = await fetchRefreshToken(currentRefreshToken, bearerToken);
  const { authorisationToken, refreshToken: newRefreshToken } = response.data;
  setStoredTokens(authorisationToken, newRefreshToken, tokenType);
  return { authorisationToken, newRefreshToken };
};

export const addAuthorizationHeader = async (config: InternalAxiosRequestConfig<any>) => {
  const { authorisationToken } = await getStoredTokens();
  if (authorisationToken) {
    config.headers['Authorization'] = `Bearer ${authorisationToken}`;
  } else {
    const refreshData = await getNewToken();
    config.headers['Authorization'] = `Bearer ${refreshData.authorisationToken}`;
  }
  return config;
};
